import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, InputAdornment } from '@mui/material';
import { Table } from 'antd';
import dayjs from 'dayjs';
import AppButton from '../../../../components/ui/AppButton';
import AppInput from '../../../../components/ui/AppInput';
import { useGetEvaluation } from '../../../../hooks/useEvaluation';

const columns = [
  {
    title: 'ชื่อผู้รับ',
    key: 'received_name',
    width: 220,
    sorter: true,
    align: 'center',
    render: (value, row) => row.user_id?.displayName || row.user_id?.lineuserid || '-',
  },
  {
    title: 'ชื่อผู้ส่ง',
    key: 'sender_name',
    width: 220,
    sorter: true,
    align: 'center',
    render: (value, row) => row.admin_id?.displayName || row.admin_id?.lineuserid || '-',
  },
  {
    title: 'คะแนน',
    dataIndex: 'rating',
    key: 'rating',
    width: 140,
    sorter: true,
    align: 'center',
    render: (value) => value || '-',
  },
  {
    title: 'ข้อเสนอแนะ',
    dataIndex: 'comment',
    key: 'comment',
    sorter: true,
    align: 'center',
    render: (value) => value || '-',
  },
  {
    title: 'Create Timestamp',
    dataIndex: 'create_timestamp',
    key: 'create_timestamp',
    width: 200,
    align: 'center',
    render: (value) => (value ? dayjs(value).format('DD/MM/YYYY HH:mm:ss') : '-'),
  },
];

const ListEvaluationTab = () => {
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState({
    page: 1,
    limit: 10,
    sort_col: undefined,
    sort_value: true,
    search: undefined,
  });
  const { data: evaluationData, isLoading: evaluationLoading } = useGetEvaluation(query);

  const handleSearch = () => {
    setQuery((prev) => ({
      ...prev,
      page: 1,
      search: search || undefined,
    }));
  };

  return (
    <Box
      sx={{
        padding: '16px',
        backgroundColor: 'white',
        borderBottomLeftRadius: '15px',
        borderBottomRightRadius: '15px',
        border: '2px solid white',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        '& .ant-pagination': {
          alignItems: 'center',
        },
        '& .ant-pagination-options': {
          alignSelf: 'center',
        },
      }}
    >
      <Box display="flex" alignItems="center" gap={1} mb={2} sx={{ maxWidth: 500, width: '100%' }}>
        <AppInput
          placeholder="ค้นหาชื่อไลน์"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#004B61' }} />
              </InputAdornment>
            ),
          }}
        />
        <AppButton variant="dangerStrong" onClick={handleSearch}>
          ค้นหา
        </AppButton>
      </Box>

      <Table
        bordered
        rowKey="_id"
        columns={columns}
        dataSource={evaluationData?.Data.data || []}
        loading={evaluationLoading}
        pagination={{
          current: query.page,
          pageSize: query.limit,
          total: evaluationData?.Data.total || 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500'],
          hideOnSinglePage: true,
        }}
        onChange={(pagination, filters, sorter) => {
          setQuery((prev) => ({
            ...prev,
            page: pagination.current,
            limit: pagination.pageSize,
            sort_col: sorter.field || undefined,
            sort_value: sorter.order === 'ascend',
          }));
        }}
        scroll={{
          x: 'max-content',
        }}
        rowHoverable={true}
      />
    </Box>
  );
};

export default ListEvaluationTab;
